import AttendanceHistory from './component';
import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';

export default ({ getState }) => ({
  path: 'history',
  component: AttendanceHistory,
  breadcrumbLabels: {
    label: 'History',
    clickable: false,
  },
  canAccess: () => {
    const state = getState();
    if (PrivilegeChecker.hasPrivilege(state, Privileges.MarkAttendance.ViewDayView) ||
        PrivilegeChecker.hasPrivilege(state, Privileges.MarkAttendance.ViewCourseView)) {
      return true;
    }
    return false;
  },
});



// WEBPACK FOOTER //
// ./containers/Group/Attendance/AttendanceHistory/routes.js